import { Injectable } from '@angular/core'
import { WindowRef } from '@spartacus/core'

export interface EbAnalyticsWindow extends Window {
  gtag?(command: string, field: string, value?: string)
}

@Injectable({
  providedIn: 'root'
})
export class EbAnalyticsWindowRef extends WindowRef {
  get nativeWindow(): EbAnalyticsWindow {
    return super.nativeWindow
  }
}
